module.exports = __webpack_public_path__ + "static/1-8938399addca5df1835a2f71aaf25dc7.jpeg";